<template>
    <div class="d-flex justify-center ribbon position-relative cursor-pointer">
        <img :src="ribbonImg" alt="" srcset="" />
        <div class="position-absolute favorite transition-all">
            <img
                :src="selected ? favoriteImg : unfavoriteImg"
                alt=""
                srcset=""
                class="transition-all"
            />
        </div>
    </div>
</template>
<script>
/* eslint-disable global-require */

export default {
    props: {
        selected: { type: Boolean, default: false },
    },
    data() {
        return {
            ribbonImg: require('@/assets/img/favorite/ribbon.svg'),
            favoriteImg: require('@/assets/img/favorite/icon-favorito-selected.svg'),
            unfavoriteImg: require('@/assets/img/favorite/icon-favorito.svg'),
        }
    },
}
</script>

<style>
.ribbon img {
    margin-right: 3vw;
    z-index: 1;
}
.favorite {
    z-index: 2;
}

@media only screen and (min-width: 1000px) {
    .ribbon img {
        margin-right: 2vw;
    }
    .favorite {
        top: 1vh;
    }
    .favorite:hover img {
        width: 7vw;
        height: 10vh;
    }
}
@media only screen and (min-width: 1400px) {
    .favorite:hover img {
        width: 4.5vw;
        height: 7.5vh;
    }
}
@media only screen and (min-width: 1904px) {
    .ribbon img {
        width: 8vw;
        height: 14vh;
        margin-right: 0vw;
    }
    .favorite img {
        width: 5vw;
        height: 8vh;
    }
    .favorite:hover img {
        width: 5.5vw;
        height: 8.5vh;
    }
}
</style>
